import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Label,
  FormGroup,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";

import Icon from "react-icons-kit";
import { ic_check } from "react-icons-kit/md/ic_check";
import { ic_close } from "react-icons-kit/md/ic_close";

import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";

import get from "lodash/get";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import config from "../../utils/config";
import history from "../../history";
import AddNewTestimonial from "../AddNewTestimonial";
import UpdateModerationModal from "../UpdateModerationModal";
import InputText from "../InputText";
import { approveRejectUpdatedTestimonialDetails } from "../../redux/Testimonials/action";
import { fetchingTestimonialCountriesJson } from "../../redux/Global/actions";

export default function TestimonialDetails(props) {
  const _ = { get };
  const dispatch = useDispatch();
  const { usertype } = useSelector((state) => state.Auth);
  const { elements } = useSelector((state) => state.Elements);
  const [toggleAddModal, setToggleAddModal] = useState(false);
  const [testModal, setTestModal] = useState(false);
  const [activeCollapse, setActiveCollapse] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectionReasonToggle, setRejectionReasonToggle] = useState(false);
  const { fetchingUpdatedDetails, updatedDetails } = useSelector(
    (state) => state.Testimonials
  );
  useEffect(() => {
    if (props.selectedId) {
      props.handleFetchTestimonialDetails(props.selectedId);
    }
    fetchingTestimonialCountriesJson();
  }, [props.selectedId]);

  const handleGoBack = () => {
    props.handleToggleModel();
    props.handleBackCall();
  };

  const handleUpdate = () => {
    history.push(`/moderation/testimonails-edit?id=${props.selectedId}`);
  };

  const handleBackCallOnSubmit = () => {
    // setRejectionReasonToggle(!rejectionReasonToggle);
    props.handleFetchTestimonialDetails(props.selectedId);
  };

  const handleBackCallRejectedOnSubmit = () => {
    setRejectionReasonToggle(!rejectionReasonToggle);
    props.handleFetchTestimonialDetails(props.selectedId);
  };

  const handleEdit = () => {
    setToggleAddModal(!toggleAddModal);
  };
  const ToggleCollapse = () => {
    setActiveCollapse(!activeCollapse);
  };
  const handleModalPreview = () => {
    setTestModal(!testModal);
    props.handleFetchTestimonialDetails(props.selectedId);
  };

  const approveOnClick = () => {
    let data = {
      testimonialId: props.selectedId,
      status: "APPROVED",
      key: "ALL",
    };
    dispatch(
      approveRejectUpdatedTestimonialDetails(data, handleBackCallOnSubmit)
    );
  };

  const rejectionOnSubmit = () => {
    let data = {
      testimonialId: props.selectedId,
      status: "REJECTED",
      rejectionReason: rejectionReason,
      key: "ALL",
    };
    if (rejectionReason !== "") {
      dispatch(
        approveRejectUpdatedTestimonialDetails(
          data,
          handleBackCallRejectedOnSubmit
        )
      );
    }
  };

  useEffect(() => {
    if (updatedDetails && updatedDetails.status === "APPROVED") {
      handleModalPreview();
    }
  }, [updatedDetails]);

  return (
    <React.Fragment>
      <div className="hideSearch mt-4">
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={`${props &&
                  props.testimonialsDetailsData &&
                  props.testimonialsDetailsData.author} by ${props &&
                  props.testimonialsDetailsData &&
                  props.testimonialsDetailsData.createdBy &&
                  props.testimonialsDetailsData.createdBy.name}`}
                iconClass={"hideexcel"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              {usertype &&
                (usertype === "EU Tours Admin" || usertype === "Admin") && (
                  <Row>
                    <Col md="12">
                      <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                        <span>
                          {_.get(
                            elements,
                            "euToursElement.testimonialDetailsElement.subheadingElement",
                            "Partner Detail"
                          )}
                        </span>
                      </h2>
                    </Col>
                    <Col
                      xl={12}
                      lg={12}
                      md={6}
                      sm={6}
                      className="mb-4 mt-3 d-flex align-items-start justify-content-between updateBox"
                    >
                      <DesignCard
                        name={_.get(
                          elements,
                          "euToursElement.testimonialDetailsElement.nameElement",
                          "Name"
                        )}
                        titleName={
                          props &&
                          props.testimonialsDetailsData &&
                          props.testimonialsDetailsData.createdBy &&
                          props.testimonialsDetailsData.createdBy.name
                            ? props.testimonialsDetailsData.createdBy.name
                            : "N/A"
                        }
                      />
                      {console.log("props", props)}
                      {props &&
                        props.testimonialsDetailsData &&
                        props.testimonialsDetailsData.moderationStatus ===
                          "MODIFIED" && (
                          <CustomButton
                            customType={"button"}
                            name="Update"
                            customClass={
                              "btn-outline-dark bg-none btnthemeColor partner_p_button"
                            }
                            customClick={() => {
                              handleModalPreview();
                            }}
                          />
                        )}
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                      <DesignCard
                        name={_.get(
                          elements,
                          "euToursElement.testimonialDetailsElement.emailElement",
                          "Email"
                        )}
                        titleName={
                          props &&
                          props.testimonialsDetailsData &&
                          props.testimonialsDetailsData.createdBy &&
                          props.testimonialsDetailsData.createdBy.email
                            ? props.testimonialsDetailsData.createdBy.email
                            : "N/A"
                        }
                      />
                    </Col>
                  </Row>
                )}
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor d-flex align-items-start justify-content-between updateBox">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.testimonialDetailsElement.testimonailSubheadingElement",
                        "Testimonial Detail"
                      )}
                    </span>
                    {usertype &&
                      usertype === "EU Tours Partner" &&
                      props &&
                      props.testimonialsDetailsData &&
                      props.testimonialsDetailsData.moderationStatus ===
                        "MODIFIED" && (
                        <CustomButton
                          customType={"button"}
                          name="Update"
                          customClass={
                            "btn-outline-dark bg-none btnthemeColor partner_p_button"
                          }
                          customClick={() => {
                            handleModalPreview();
                          }}
                        />
                      )}
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.testimonialDetailsElement.rdierNameElement",
                      "Rider Name"
                    )}
                    titleName={
                      props &&
                      props.testimonialsDetailsData &&
                      props.testimonialsDetailsData.author
                        ? props.testimonialsDetailsData.author
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.testimonialDetailsElement.riderLocationElement",
                      "Rider Location"
                    )}
                    titleName={
                      props &&
                      props.testimonialsDetailsData &&
                      props.testimonialsDetailsData.location
                        ? props.testimonialsDetailsData.location
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.testimonialDetailsElement.postedDateElement",
                      "Posted Date"
                    )}
                    titleName={
                      props &&
                      props.testimonialsDetailsData &&
                      props.testimonialsDetailsData.postedDate
                        ? moment(
                            props.testimonialsDetailsData.postedDate
                          ).format("DD-MM-YYYY")
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={12} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.testimonialDetailsElement.riderNoteElement",
                      "Rider Note"
                    )}
                    titleName={
                      props &&
                      props.testimonialsDetailsData &&
                      props.testimonialsDetailsData.description
                        ? props.testimonialsDetailsData.description
                        : "N/A"
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-5">
                  <div className="image_heading">
                    {_.get(
                      elements,
                      "euToursElement.testimonialDetailsElement.riderImageElement",
                      "Rider Image/Default image  (80 x 80 px)"
                    )}
                  </div>
                  {props &&
                  props.testimonialsDetailsData &&
                  props.testimonialsDetailsData.image &&
                  props.testimonialsDetailsData.image.images[0] &&
                  props.testimonialsDetailsData.image.images[0].srcPath ? (
                    <img
                      className="image_bikeman"
                      src={`${config.imageBaseUrl}/${props &&
                        props.testimonialsDetailsData &&
                        props.testimonialsDetailsData.image &&
                        props.testimonialsDetailsData.image.images[0] &&
                        props.testimonialsDetailsData.image.images[0].srcPath}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
              </Row>

              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "euToursElement.testimonialDetailsElement.backElement",
                    "Back"
                  )}
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={(e) => handleGoBack(e)}
                />
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "euToursElement.testimonialDetailsElement.editElement",
                    "Update"
                  )}
                  customClass={"btn-outline-dark bg-none ml-3 btnthemeColor"}
                  customClick={(e) => handleEdit(e)}
                />
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.testimonialDetailsElement.moderateElement",
                        "Moderate"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={(e) => handleUpdate(e)}
                    />
                  )}
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") && (
                    <CustomButton
                      customType={"button"}
                      name="Delete"
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() => props.handleRejectModal()}
                    />
                  )}
              </div>
            </CardBody>
          </Card>
        </Form>
        <Modal
          isOpen={toggleAddModal}
          toggle={() => setToggleAddModal(!toggleAddModal)}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <AddNewTestimonial
              handleToggleModel={() => setToggleAddModal(!toggleAddModal)}
              testimonialsDetailsData={props.testimonialsDetailsData}
              formType={
                usertype &&
                (usertype === "EU Tours Admin" || usertype === "Admin")
                  ? "create"
                  : "update"
              }
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={testModal}
          toggle={() => handleModalPreview()}
          className="update_preview_modal"
          centered
          scrollable
          size="lg"
        >
          <ModalHeader className="d-block">
            <div className="d-flex justify-content-between flex-column flex-lg-row light-border-bottom header-bg main-title align-items-center py-2 px-2 rounded">
              <div className="CartTitle d-flex align-items-center  justify-content-lg-start justify-content-center">
                <h4 className="text-light text-capitalize m-0 ml-2">
                  <span>Testimonial Information</span>
                </h4>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <UpdateModerationModal
              wanderlustId={props && props.selectedId}
              category={"Testimonial"}
              handleBackCallOnSubmit={handleBackCallOnSubmit}
            />
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"button"}
              name="Close"
              customClass={"btn-outline-dark bg-none btnthemeColor"}
              customClick={() => handleModalPreview()}
            />
            {usertype &&
              (usertype === "EU Tours Admin" || usertype === "Admin") && (
                <CustomButton
                  customType={"button"}
                  name="Approve All"
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() => approveOnClick()}
                />
              )}
            {usertype &&
              (usertype === "EU Tours Admin" || usertype === "Admin") && (
                <CustomButton
                  customType={"button"}
                  name="Reject All"
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() =>
                    setRejectionReasonToggle(!rejectionReasonToggle)
                  }
                />
              )}
          </ModalFooter>
        </Modal>
        <Modal isOpen={rejectionReasonToggle} backdrop={true} centered={true}>
          <ModalHeader
            toggle={() => {
              setRejectionReasonToggle(!rejectionReasonToggle);
              setRejectionReason("");
            }}
          >
            {_.get(
              elements,
              "euToursElement.partnerPersonalInfoElement.rejectionModelLabel",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={rejectionReason}
              customOnChange={(e) => setRejectionReason(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "euToursElement.partnerPersonalInfoElement.rejectElement",
                "Reject"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={(e) => rejectionOnSubmit(e)}
            />
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}
